// src/socket/signalingClient.js
import { io } from "socket.io-client";

const SOCKET_URL = "https://nukkad.vemeet.online";

export const socket = io(SOCKET_URL, {
  path: "/socket.io",
  transports: ["websocket"],
  reconnection: true,
});

// CONNECTION LOGS
socket.on("connect", () => console.log("Socket connected:", socket.id));
socket.on("disconnect", (r) => console.log("Socket disconnected:", r));

// ------------------------------
// ROOM FUNCTIONS
// ------------------------------
export const joinRoom = (roomId, userId) => {
  socket.emit("join-room", { roomId, userId });
};

export const leaveRoom = (roomId, userId) => {
  socket.emit("leave-room", { roomId, userId });
};

// ------------------------------
// PEER-TO-PEER SIGNALING
// ------------------------------
export const sendOffer = ({ offer, to }) => socket.emit("offer", { offer, to });
export const sendAnswer = ({ answer, to }) => socket.emit("answer", { answer, to });
export const sendCandidate = ({ candidate, to }) => socket.emit("candidate", { candidate, to });

export const onOffer = (cb) => socket.on("offer", cb);
export const onAnswer = (cb) => socket.on("answer", cb);
export const onCandidate = (cb) => socket.on("candidate", cb);

// ------------------------------
// ROOM EVENTS
// ------------------------------
export const onRoomUsers = (cb) => socket.on("room-users", cb);       // List of other users
export const onUserJoined = (cb) => socket.on("user-joined", cb);     // New user joined
export const onUserLeft = (cb) => socket.on("user-left", cb);         // User left

// ------------------------------
// MEDIA
// ------------------------------
export const getMedia = async (video = true, audio = true) => {
  try {
    return await navigator.mediaDevices.getUserMedia({ video, audio });
  } catch (err) {
    console.error("getUserMedia error:", err);
    return null;
  }
};

// ------------------------------
// CREATE PEER CONNECTION
// ------------------------------
export const createPeerConnection = (toSocketId, onRemoteStream) => {
  const pc = new RTCPeerConnection({
    iceServers: [
      { urls: "stun:stun.l.google.com:19302" },
      {
        urls: [
          "turn:nukkad.vemeet.online:3479?transport=udp",
          "turn:nukkad.vemeet.online:3479?transport=tcp",
          "turns:nukkad.vemeet.online:5350?transport=tcp"
        ],
        username: "nukkad",
        credential: "MyTurnPass@2025",
      },
    ],
  });

  pc.ontrack = (event) => {
    console.log("Remote stream received");
    onRemoteStream(event.streams[0]);
  };

  pc.onicecandidate = (event) => {
    if (event.candidate) {
      sendCandidate({ candidate: event.candidate, to: toSocketId });
    }
  };

  return pc;
};
